export default __webpack_public_path__ + "static/media/queen_of_cups.78398f0d.png";